<template>
  <div class="select-wrapper">
    <ul>
      <li @click="toItem('day')" :class="[{'btn-primary2':current==='day'}]">今日</li>
      <li @click="toItem('month')" :class="[{'btn-primary2':current==='month'}]">本月</li>
      <li @click="toItem('byself')" :class="[{'btn-primary2':current==='byself'}]">自定义</li>
    </ul>
    <DatePicker type="daterange"
                placeholder=""
                style="width: 270px;"
                v-model="date"
                @on-change="changeType"
                :options="disabledDate?dateOption:null"
                :clearable="false"
                split-panels
                :key="'others'"
                :disabled="current!=='byself'"
    ></DatePicker>
    <Button :disabled="current!=='byself'" @click="ok">确定</Button>
  </div>
</template>

<script>
  import {formatDateTime} from "../../../utils/format";

  export default {
    name: "SelectRange",
    props:{
      disabledDate:{
        type:Boolean,
        default:true
      }

    },
    data() {
      return {
        current: 'day',
        date: ['', ''],
        year: '',  //年
        month: '',  //月
        day: '',  //日
        dateOption: {
          disabledDate(date) {
            return date && date.valueOf() > Date.now();
          }
        },
        timer: null
      }
    },
    computed: {
      searchParams(){
        return {
          startDate:formatDateTime(this.date[0],false).replace(/-/g,'.'),
          endDate:formatDateTime(this.date[1],false).replace(/-/g,'.'),

        }

      }
    },
    mounted(){
      this.$emit('search',this.searchParams)

    },

    methods: {
      ok(){
        this.$emit('search',this.searchParams)

      },
      changeType(){
        // this.current='byself'
      },
      toItem(current) {
        // this.$emit('clickItem', current)
        this.current = current
        if (current === 'day') {
          this.setToday()
          this.$emit('search',this.searchParams)
        }
        if (current === 'month') {
          this.setMonth()
          this.$emit('search',this.searchParams)
        }
      },
      setToday(){
        this.date=[new Date(),new Date()]
      },
      setMonth(){
        this.date=[new Date(this.year,this.month,1),new Date()]
      },

      initData() {
        const date = new Date()
        this.year = date.getFullYear()
        this.month = date.getMonth()
        this.day = date.getDate()
      },
    },
    created() {
      this.initData()
      this.setToday()
    }
  }
</script>
<style scoped>
  ul, li {
    display: inline;
  }
  ul li {
    cursor: pointer;
    margin-right: 10px;
    background-color: transparent!important;
  }
  .select-wrapper{
    font-size: 12px;
    font-weight: normal;
  }
</style>
